import { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Box,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import moment from "moment";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation } from "@apollo/client";
//Import from project
import "../../../Style/dialogstyle.scss";
import useGetEnrollmentByClassAndStudent from "../../../Hooks/useGetEnrollmentByClassAndStudent";
// import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";
import { AuthContext } from "../../../Context/AuthContext";
import { NOTE_STUDENT_COMPLETE_CLASS } from "../../../Schema/Class";

export default function NoteStudentComplete({
  open,
  editData,
  classId,
  setRefetch,
  handleClose,
  noteData,
}) {
  // Change Language
  const { setAlert, t } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const { tableData: enrollmentData } = useGetEnrollmentByClassAndStudent({
    classId: classId,
    studentId: editData?._id,
  });

  const [noteStudentComplete] = useMutation(NOTE_STUDENT_COMPLETE_CLASS, {
    onCompleted: ({ noteStudentComplete }) => {
      setLoading(false);
      if (noteStudentComplete?.isSuccess === true) {
        setAlert(true, "success", noteStudentComplete?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", noteStudentComplete?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageEn: message, messageKh: message });
    },
  });

  const ValidationSchema = Yup.object().shape({
    date: Yup.string().required(t("required")),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      date: moment(),
      remark: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      //
      noteStudentComplete({
        variables: {
          id: noteData?._id ? noteData?._id : "",
          input: {
            enrollmentId: enrollmentData?._id,
            date: moment(values?.date)?.format("YYYY-MM-DD"),
            remark: values?.remark,
          },
        },
      });
    },
  });

  const { resetForm, setFieldValue, handleSubmit, getFieldProps } = formik;

  useEffect(() => {
    if (open) {
      setFieldValue("date", noteData?.date);
      setFieldValue("remark", noteData?.remark ?? "");
    }
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="flex-end"
          justifyContent="center"
        >
          <Typography className="dialog-title">
            {t("modal_title_note_student_complete")}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              {/* <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.date}
                  onChange={(val) => setFieldValue("date", val || "")}
                />
                {!!errors.date && touched.date && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.date}
                  </FormHelperText>
                )}
              </Grid> */}

              <Grid item xs={12} md={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  rows={10}
                  fullWidth
                  multiline
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("save")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
